import TextField from "../../../../components/fields/textField/TextField.vue";
import SelectField from "../../../../components/fields/selectField/SelectField.vue";
import PeriodoField from "../../../../components/fields/periodoField/PeriodoField.vue";
import TextAreaField from "../../../../components/fields/textAreaField/TextAreaField.vue";
import FileInputField from "../../../../components/fields/file-input-field/FileInputField.vue";
import { SnackBarModule } from "../../../../modules/SnackBarModule";
import moment from "moment";
import { AJUSTAR_FERIAS_TIPO_ALTERACAO, tipoAlteracaoEnum, TiposFeriasEnum} from "../../../../constants";
import { AjustarFeriasCivilService } from "../../../../services/AjustarFeriasCivilService";
import { SolicitarFeriasCivilService } from "../../../../services/SolicitarFeriasCivilService";
import { calcularDiasCorridos } from "../../../../helper/helper.js";



export default {
  name: "AjustarFerias",

  props: {
    selected: {
      required: true,
      default: [],
    },
    isOpen: {
      type: Boolean,
      required: true,
    }
  },

  components: {
    TextField,
    SelectField,
    PeriodoField,
    TextAreaField,
    FileInputField
  },

  beforeMount() {
    this.initializeForm();
    this.inicializarModal();
    this.getJustificativa(this.selected.idFerias);

  },

  computed: {
    enumTipoAlteracao() {
      return tipoAlteracaoEnum;
    }
  },


  mounted() {
    this.options.tipoAlteracao = AJUSTAR_FERIAS_TIPO_ALTERACAO;
  },

  data: () => ({
    id: null,

    idJustificativa:0,

    limiteDias: 25,
    numeroDiasTitulo: 'Número de dias úteis solicitados',
    titulo: 'Ajustar Férias',




    justificativa: "",
    form: {},
    options: {
      tipoAlteracao: [],
    },

    loading: {
      field: false,
      btn: false,
    }
  }),

  watch: {
    isOpen: function (isOpen) {
      if (isOpen) {
        this.getJustificativa(this.selected.idFerias);
        this.inicializarModal();
  
      }
    },
 
  },

  methods: {
    inicializarModal(){
      if(this.selected.idTipo == TiposFeriasEnum['FERIAS_PREMIO']){
        this.limiteDias = 90
        this.titulo = 'Ajustar Férias Prêmios'
        this.numeroDiasTitulo = 'Número de dias corridos solicitados';
      }else{
        this.limiteDias = 25
        this.titulo = 'Ajustar Férias'
        this.numeroDiasTitulo = 'Número de dias úteis solicitados';
      }
    },
    async getJustificativa(id) {
      this.loading.field = true;
      const response = await AjustarFeriasCivilService.getById(id);
      this.justificativa = response.justificativa;
      this.idJustificativa = response.id
      this.loading.field = false;
    },

    async calculateDays() {
  
      if (this.form.dataInicio) {
        if(this.selected.idTipo != TiposFeriasEnum['FERIAS_PREMIO']){

        const formData = new FormData();
        formData.append("data_ini", moment(this.form.dataInicio).format("YYYY-MM-DD"));
        formData.append("dias",this.form.numeroDias);
        const response =  await SolicitarFeriasCivilService.calcularDiasUteis(formData);
        this.form.dataFim = response.dataFim;
        this.form.numeroDias = response.dias_uteis;
        return;
        } 
        this.form.dataFim = calcularDiasCorridos(this.form.dataInicio, this.form.numeroDias)
        return;

      }
      return SnackBarModule("Prencha o campo de data inicial", "error");
    },

    calculateFinalDate() {
      const finalDate = moment(this.form.dataInicio).add(this.form.numeroDias, 'days');
      if (this.form.dataInicio) {
        this.form.dataFim = moment(finalDate).format("YYYY-MM-DD");
        return;
      }
      SnackBarModule("Prencha o campo de data inicial", "error");
    },

    cleanCalculate() {
      this.form.dataFim = null;
      this.form.numeroDias = null;
      SnackBarModule("Preencha os outros campos para realizar o cálculo", "error");
    },

    initializeForm() {
      this.form = {
        tipoAlteracao: null,
        dataInicio: null,
        dataFim: null,
        numeroDias: null,
        anexo: null
      }
    },

    prepareForm() {
      if (this.$refs.form.validate()) {
        const formData = new FormData();
        formData.append("data_ini", this.form.dataInicio);
        formData.append("data_fin", this.form.dataFim);
        formData.append("dias", this.form.numeroDias);
        this.form.anexo != null ?  formData.append("arquivo", this.form.anexo) : null;
        formData.append("id_ferias", this.selected.idFerias);
        formData.append("id_tipos_alteracao_ajuste_ferias", this.form.tipoAlteracao);
        formData.append("id_recusa_justificativa", this.idJustificativa);
        formData.append("justificativa", this.justificativa);

        this.saveForm(formData);
        return;
      }
      SnackBarModule("Campo(s) obrigatório(s) não informado(s).", "error");
    },

    async saveForm(formData) {
      this.loading.btn = true;
      const response = await AjustarFeriasCivilService.ajustarFerias(formData);
      this.loading.btn = false;
      this.$emit('on-confirm');
      if (response) {
        this.close();
      }
    },

    close() {
      this.$refs.form.reset();
      this.$emit("on-close");
    },
  },
};